
<section class="UsersView">
  <div class="container">
    <div class="columns">
      <div class="column is-10 is-offset-1">
        <h2>Lista użytkowników</h2>
        <users-table @user-click="$emit('user-click', $event)" @order-click="$emit('order-click', $event)"/>
      </div>
    </div>
  </div>
  <Footer/>
</section>
